import { draggable } from "common";
import { FilterDragHandler } from './FilterDragHandler';
import { UserFilterGroupInstance } from "./UserFilterGroupInstance";
import { setUserFilters, userFilters } from "./UserFilterStore";
import { viewFilters as api } from 'st-app/api'
import { FilterInfoInstance, SharedFilterInstance } from "./FilterInfoInstance";

type IDropHandler = draggable.IDropHandler
type IDragHandler = draggable.IDragHandler

export enum InsertLocation {
    Before,
    Into,
    After
}

export class FilterGroupDropFilterHandler implements IDropHandler {
    name: string = 'st-view-filter';
    group: UserFilterGroupInstance;

    constructor(group: UserFilterGroupInstance) {
        this.group = group;
    }

    receiveFilter(handler: FilterDragHandler) {
        const filter = new FilterInfoInstance(handler.filter);
        filter.filterGroupGU = this.group.filterGroupGU;
        setUserFilters('allFilters', (f) => f.filterGU === filter.filterGU, filter);

        api.UpdateFilterGroup(filter.filterGU!, filter.filterGroupGU!);
    }

    drop(ev: DragEvent, dragHandler: IDragHandler): void {
        if (dragHandler instanceof FilterDragHandler) {
            if (dragHandler.filter instanceof SharedFilterInstance) {
                userFilters.acceptSharedFilter(dragHandler.filter, this.group.filterGroupGU);
            }
            else {
                this.receiveFilter(dragHandler);
            }
        }

        this.group.isDropTarget[1](false);
    }

    enter(ev: DragEvent, dragHandler: IDragHandler): void {
        this.group.isDropTarget[1](true);
    }

    leave(ev: DragEvent, dragHandler: IDragHandler): void {
        this.group.isDropTarget[1](false);
    }

    over(ev: DragEvent, dragHandler: IDragHandler): void {
    }
}

export class FilterGroupDropGroupHandler implements IDropHandler {
    name: string = 'st-view-filter-group';
    group: UserFilterGroupInstance;

    constructor(group: UserFilterGroupInstance) {
        this.group = group;
    }

    receiveGroup(folder: Element, handler: FilterGroupInstanceDragHandler) {
        const adj = folder.classList.contains('drag-hover-bottom') ? 1 : 0;
        const groups = userFilters.allGroups
            .map(g => new UserFilterGroupInstance(g))
            .sort((a, b) => a.order - b.order);
        const dstGroup = groups.find(g => g.filterGroupGU === this.group.filterGroupGU);
        const srcGroup = groups.find(g => g.filterGroupGU === handler.group.filterGroupGU);

        if (srcGroup) {
            groups.splice(groups.indexOf(srcGroup), 1);

            if (dstGroup) {
                groups.splice(groups.indexOf(dstGroup) + adj, 0, srcGroup);
            }
            else {
                groups.push(srcGroup);
            }

            let order = 0;
            for (const group of groups) {
                group.order = order++;
            }

            setUserFilters('allGroups', groups);
            api.UpdateGroupOrder(groups);
        }
    }

    drop(ev: DragEvent, dragHandler: IDragHandler): void {
        const folder = (ev.target as HTMLElement)?.closest('.folder');
        if (folder) {
            if (dragHandler instanceof FilterGroupInstanceDragHandler) {
                this.receiveGroup(folder, dragHandler);
            }

            folder.classList.remove('drag-hover-top');
            folder.classList.remove('drag-hover-bottom');
        }

        this.group.isDropTarget[1](false);
    }

    enter(ev: DragEvent, dragHandler: IDragHandler): void {
        this.group.isDropTarget[1](true);
    }

    leave(ev: DragEvent, dragHandler: IDragHandler): void {
        this.group.isDropTarget[1](false);

        const folder = (ev.target as HTMLElement)?.closest('.folder');
        if (folder) {
            folder.classList.remove('drag-hover-top');
            folder.classList.remove('drag-hover-bottom');
        }
    }

    over(ev: DragEvent, dragHandler: IDragHandler): void {
        const folder = (ev.target as HTMLElement)?.closest('.folder');
        if (folder) {
            const rect = folder.getBoundingClientRect();

            if (ev.pageY < rect.top + (rect.height / 2)) {
                folder.classList.add('drag-hover-top');
                folder.classList.remove('drag-hover-bottom');
            }
            else {
                folder.classList.add('drag-hover-bottom');
                folder.classList.remove('drag-hover-top');
            }
        }
    }
}

export class FilterGroupInstanceDragHandler implements IDragHandler {
    name: string = 'st-view-filter-group';
    handle?: HTMLElement;
    group: UserFilterGroupInstance;

    constructor(group: UserFilterGroupInstance) {
        this.group = group;
    }

    start(ev: DragEvent): void {
        this.group.isDragging[1](true);
    }

    stop(ev: DragEvent): void {
        this.group.isDragging[1](false);
    }
}
